import React, { useState } from 'react';
import { MdMoreVert } from 'react-icons/md';
import { MenuDirection } from './types';
import Menu from './Menu';
import { IconButtonLegacy } from '../IconButton';
import { IconButtonSize } from '../../types';
/**
 * @deprecated
 */
var IconMenuButton = function (props) {
    var disabled = props.disabled, items = props.items, menuDirection = props.menuDirection, minWidth = props.minWidth, color = props.color, WrapperComponent = props.WrapperComponent, elementId = props.elementId;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    // handle open close menu
    var handleOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var isOpen = Boolean(anchorEl);
    var iconButton = (React.createElement(IconButtonLegacy, { onClick: handleOpen, size: IconButtonSize.medium, disabled: disabled, icon: MdMoreVert, "data-testid": elementId, color: color, style: { fontSize: '1.8rem' } }));
    var menuButton = WrapperComponent ? (React.createElement(WrapperComponent, null,
        React.createElement("span", null, iconButton))) : (iconButton);
    return (React.createElement(React.Fragment, null,
        menuButton,
        React.createElement(Menu, { menuDirection: menuDirection, items: items, onClose: handleClose, open: isOpen, anchorEl: anchorEl, minWidth: minWidth })));
};
IconMenuButton.defaultProps = {
    menuDirection: MenuDirection.Default,
    disabled: false,
    elementId: '',
};
export default IconMenuButton;
//# sourceMappingURL=IconMenuButton.js.map